import { current } from '@reduxjs/toolkit';
import { OfflineOrderingState, SelectedTopping } from '../types';

const selectTopping = (state: OfflineOrderingState, selected: SelectedTopping): OfflineOrderingState => {
  if (selected.topping.length === 0) return state;

  const find = current(state.selectedTopping).find((x) => x.toppingCategoryId === selected.toppingCategoryId);
  if (find) {
    return {
      ...state,
      selectedTopping: state.selectedTopping.map((item) => {
        if (item.toppingCategoryId === selected.toppingCategoryId) {
          return {
            ...item,
            topping: selected.topping,
          };
        }
        return item;
      }),
    };
  }

  return {
    ...state,
    selectedTopping: [...state.selectedTopping, selected],
  };
};

export default selectTopping;
